import { Modal } from "components/modals"
import { useEffect, useState } from "react"
import { Text } from 'components/texts'
import { Edit as EditIcon, Search as SearchIcon } from '@mui/icons-material'
import { Grid } from '@mui/material'
import { Button } from "components/forms/components"
import { COLOR } from "theme/Colors"
import { ChooseListCreate, FastCreateFormResponsableCreate } from "components/forms/display"

const CREATE_BUTTON = 1
const ASOCIATE_BUTTON = 2

export default function AddResponsableModalCreate({ register, getValues, errors, addResponsableModalCreateRef, open, setOpen, setResponsables }) {
    const [buttonSelected, setButtonSelected] = useState(CREATE_BUTTON)

    const buttonClicked = (buttonSelected) => setButtonSelected(buttonSelected)

    useEffect(() => {
        if (open) {
            addResponsableModalCreateRef.current.open()
            setOpen(false)
        }
    }, [open])

    return (
        <Modal ref={addResponsableModalCreateRef} title={"Añadir un tutor"}>
            <Grid container pb={5} pt={2} px={5}>
                <Grid item xs={12} display={"flex"} justifyContent={"center"}>
                    <Text fontWeight={"bold"}>Puedes crear un nuevo tutor o escoger uno ya existente.</Text>
                </Grid>

                <Grid container my={2}>
                    <Grid item xs={6} display={"flex"} justifyContent={"end"} alignSelf={"end"} pr={1}>
                        <Button
                            startIcon={<EditIcon style={{ color: buttonSelected == CREATE_BUTTON ? COLOR.white.main : COLOR.standard.main }} />}
                            variant={buttonSelected == CREATE_BUTTON ? "contained" : "outlined"}
                            onClick={() => buttonClicked(CREATE_BUTTON)}>
                            Crear nuevo
                        </Button>
                    </Grid>

                    <Grid item xs={6} pl={1}>
                        <Button
                            startIcon={<SearchIcon style={{ color: buttonSelected == ASOCIATE_BUTTON ? COLOR.white.main : COLOR.standard.main }} />}
                            variant={buttonSelected == ASOCIATE_BUTTON ? "contained" : "outlined"}
                            onClick={() => buttonClicked(ASOCIATE_BUTTON)} >
                            Escoger de la lista
                        </Button>
                    </Grid>
                </Grid>

                {buttonSelected == CREATE_BUTTON ?
                    <FastCreateFormResponsableCreate
                        setOpen={setOpen}
                        addResponsableModalCreateRef={addResponsableModalCreateRef}
                        register={register}
                        getValues={getValues}
                        errors={errors}
                        setResponsables={setResponsables} /> :

                    <ChooseListCreate
                        addResponsableModalCreateRef={addResponsableModalCreateRef}
                        register={register}
                        setResponsables={setResponsables} />}
            </Grid>
        </Modal>
    )
}